import React, { createContext, useContext, useState } from 'react';

import { LocalFile } from '@graphql/generated';

type TaskCreateFooterContext = {
  localFiles: LocalFile[];
  setLocalFiles: React.Dispatch<React.SetStateAction<LocalFile[]>>;
  selectedList1: [];
  setSelectedList1: React.Dispatch<React.SetStateAction<[]>>;
  isReadySubmitting: boolean;
  setIsReadySubmitting: React.Dispatch<React.SetStateAction<boolean>>;
  isAddAssignee: boolean;
  setIsAddAssignee: React.Dispatch<React.SetStateAction<boolean>>;
};

const taskCreateFooterContext = createContext<
  TaskCreateFooterContext | undefined
>(undefined);

export const TaskCreateFooterProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { Provider } = taskCreateFooterContext;
  const [localFiles, setLocalFiles] = useState<LocalFile[]>([]);
  const [selectedList1, setSelectedList1] = useState<[]>([]);
  const [isReadySubmitting, setIsReadySubmitting] = useState<boolean>(false);
  const [isAddAssignee, setIsAddAssignee] = useState<boolean>(false);
  return (
    <Provider
      value={{
        localFiles,
        setLocalFiles,
        selectedList1,
        setSelectedList1,
        isReadySubmitting,
        setIsReadySubmitting,
        isAddAssignee,
        setIsAddAssignee,
      }}>
      {children}
    </Provider>
  );
};

const useTaskCreateFooter = (): TaskCreateFooterContext => {
  const context = useContext(taskCreateFooterContext);
  if (context === undefined) {
    throw new Error('useTaskCreateFooter must be used within a Provider');
  }
  return context;
};

export default useTaskCreateFooter;
